// import { i18n } from './../i18n'
//
// const i18nLocaleChange = store => {
//   // called when the store is initialized
//   store.subscribe((mutation, state) => {
//     // called after every mutation.
//     // The mutation comes in the format of `{ type, payload }`.
//     console.log('plugin', mutation)
//     console.log(state)
//     i18n.locale = 'zh'
//   })
// }

export default []
